import Grid from '@material-ui/core/Grid';
import GS from '../../grafsync/grafsync';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';

class TransferSubscriptionDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            exists: undefined
        };
    }

    transferSubscription = () => {
        const { username } = this.state;
        const exists = GS.doesUsernameExist(username);
        if (!exists) {
            this.setState(exists);
            return;
        }
        else {
            this.setState(exists);
            this.props.onTransfer({
                subscription: this.props.subscription,
                username
            });
        }
    };

    exitTransferSubscription = () => this.props.onCancel();

    handleUserChange = (event) => {
        const t = event.target;
        this.setState({
            username: t.value
        });
    };

    render() {

        const { classes } = this.props;
        const { username, exists } = this.state;

        let invalid = username === "";

        return (
            <React.Fragment>
                <Dialog className={classes.dialog}
                    open={true}
                    maxWidth="sm"
                    fullWidth
                    onClose={this.exitUpdateSubscription} aria-labelledby="transfer-subscription-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="transfer-subscription-dialog-title">Transfer Subscription</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} classes={
                            {
                                "spacing-xs-2": this.props.classes.fullGrid
                            }
                        }>
                            <Grid item xs={12}>
                                <TitledPanel dataTest="username" title="Transfer Username">
                                    <TextField
                                        onChange={this.handleUserChange}
                                        autoFocus={true}
                                        InputProps={{
                                            className: classes.inputLabel,
                                            inputProps: {
                                                "data-test": "username-input"
                                            }
                                        }}                                        
                                        variant="outlined"
                                        helperText={exists === false ? <span data-test="helper-text">Username does not exist</span> : ""}
                                        value={username} />
                                </TitledPanel>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitTransferSubscription} />
                        <PrimaryButton disabled={invalid} onClick={this.transferSubscription}>Transfer</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

TransferSubscriptionDialog.propTypes = {
    classes: PropTypes.object,
    onTransfer: PropTypes.func.isRequired,
    subscription: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default withStyles(styles)(TransferSubscriptionDialog);